import { render, staticRenderFns } from "./GiftWidgetPreview.vue?vue&type=template&id=5075f528"
import script from "./GiftWidgetPreview.vue?vue&type=script&lang=js"
export * from "./GiftWidgetPreview.vue?vue&type=script&lang=js"
import style0 from "@/giftWidget.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports